import React from "react";

const FloatingWhatsapp = ({ onClick }) => (
  <a
    href="#"
    id="waFloat"
    className="wa-float"
    aria-label="Chat on WhatsApp"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    📲 WhatsApp
  </a>
);

export default FloatingWhatsapp;
